import React from 'react';
import { Routes, Route } from 'react-router-dom';
import ProjectTitle from './ProjectTitle';

/**
 * Render the title in the application bar on the top.
 *
 * Switch based on the route. For /project/:id, render the ProjectTitle
 * component. Render a string for the other routes. Paths are relative because
 * this is a descendant <Routes> under the AppLayout `/*` route.
 */
const AppBarTitle = () => (
  <div className="flex grow flex-col my-auto border-x border-grey px-[30px] text-[18px] leading-[26px]">
    <Routes>
      <Route path="account" element="Account" />
      <Route path="project/:id" element={<ProjectTitle />} />
      {/* Catch-all, mirroring the v5 non-exact `<Route path="/">`: any
          unmatched path keeps the 'Dashboard' title rather than going blank. */}
      <Route path="*" element="Dashboard" />
    </Routes>
  </div>
);

export default AppBarTitle;
